import { FiltersContext } from '../context'

export const dimensionsActive = (filtersContext?: FiltersContext) => {
  if (!filtersContext) return false

  const { activeDimensions } = filtersContext

  return (
    !!activeDimensions.height ||
    !!activeDimensions.width ||
    !!activeDimensions.depth
  )
}